import { h, Component } from 'preact';
import { BaseField } from '../BaseField';

import { bind, memoize, debounce } from 'decko';
import Checkbox from 'preact-material-components/Checkbox';
import FormField from 'preact-material-components/FormField';

import { ICheckBoxProps, ICheckBoxState } from './ICheckBox';

//let style = require('./style.css');

export class CheckBox extends BaseField<ICheckBoxProps, ICheckBoxState> {

    constructor(props: ICheckBoxProps, ctx) {
        super(props, ctx);
        this.setState({
            value : props.value
        })
    }

    @bind
    public onChange() {
        var value = !this.state.value;
        this.setState({
            value: value
        });
        if (this.props.onChange)
            this.props.onChange(value);
    }

    render() {
        return <div class={this.props.class}>
            <FormField >
            <Checkbox
                id={`checkbox-${this.props.name}`}
                name={this.props.name}
                checked={this.state.value}
                onChange={() => { this.onChange() }}
            />
                <label for={`checkbox-${this.props.name}`}>{this.props.label}</label>
        </FormField></div>;
    }
}




// WEBPACK FOOTER //
// ./components/forms/fields/checkBox/CheckBox.tsx